import '@nephele/debug-info/index.iife.js';
import '@nephele/debug-info/style.css';
